import { render, staticRenderFns } from "./managet.vue?vue&type=template&id=66672106&scoped=true"
import script from "./managet.vue?vue&type=script&lang=js"
export * from "./managet.vue?vue&type=script&lang=js"
import style0 from "./managet.vue?vue&type=style&index=0&id=66672106&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66672106",
  null
  
)

export default component.exports